<template>
    <div class="page-first-entry">
        <!-- 主体 -->
        <div class="main-box" v-if="show.mainBox" v-loading="loading">
            <div class="title">
                请选择登录账号类型：
            </div>

            <div class="cont">
                <el-button @click="selectProp">
                    物业服务企业
                </el-button>

                <el-button @click="selectBuild">
                    建设单位、房地产开发公司
                </el-button>
            </div>
        </div>

        <!-- 成功提示 -->
        <div class="success-box" v-if="show.successBox">
            提交成功，数据正常审核中，请返回到省统一平台。
        </div>

        <!-- 完善机构信息 (弹窗) -->
        <el-dialog title="完善机构信息" :visible.sync="show.dvOrgInfo" :close-on-click-modal="false" width="80%">
            <div class="tips">
                温馨提示：因系统未在商事主体中查询到企业的完整信息，请完善企业信息。
            </div>

            <el-form class="entry-form-box" :model="infoForm" :rules="infoRules" size="small" ref="infoFormRef" show-message inline-message>
                <div class="form-row">
                    <div class="row-item">
                        <el-form-item label="企业名称：">
                            <div class="form-info">
                                {{ infoForm.OrgName }}
                            </div>
                        </el-form-item>
                    </div>

                    <div class="row-item">
                        <el-form-item label="统一社会信用代码：">
                            <div class="form-info">
                                {{ infoForm.OrgCode }}
                            </div>
                        </el-form-item>
                    </div>
				</div>
                    
				<div class="form-row">
                    <div class="row-item">
                        <el-form-item label="企业性质：" prop="Nature">
							<el-radio-group v-model="infoForm.Nature" @change="onNatureChange">
								<el-radio :label="1">独立法人</el-radio>
								<el-radio :label="2">非独立法人</el-radio>
							</el-radio-group>
                        </el-form-item>
                    </div>
				</div>

				<div class="form-row" v-if="hasNature">
                    <div class="row-item">
                        <el-form-item label="联系人：" prop="Contactser">
                            <el-input v-model="infoForm.Contactser" placeholder="请输入联系人"></el-input>
                        </el-form-item>
                    </div>

                    <div class="row-item">
                        <el-form-item label="联系人手机号码：" prop="ContactserMoblie">
                        	<el-input v-model="infoForm.ContactserMoblie" placeholder="请输入联系人手机号码"></el-input>
                        </el-form-item>
                    </div>
				</div>

				<div class="form-row" v-if="isNonIndeNature">
                    <div class="row-item">
                        <el-form-item label="隶属企业名称：" prop="RelationsName">
                        	<el-input v-model="infoForm.RelationsName" placeholder="请输入隶属企业名称" maxlength="100"></el-input>
                        </el-form-item>
                    </div>
				</div>

				<div class="form-row" v-if="isNonIndeNature">
                    <div class="row-item">
                        <el-form-item label="隶属企业统一社会信用代码：" prop="Relations">
                        	<el-input v-model="infoForm.Relations" placeholder="请输入隶属企业统一社会信用代码" maxlength="100"></el-input>
                        </el-form-item>
                    </div>
				</div>

				<div class="form-row">
                    <div class="row-item">
                        <el-form-item label="备注：">
                        	<el-input v-model="infoForm.Remark" type="textarea" :rows="2" maxlength="50"></el-input>
                        </el-form-item>
                    </div>
				</div>
            </el-form>

			<!-- 底部 -->
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" size="small" :loading="submitLoading" @click="onValid()">
					提 交
				</el-button>
			</div>
        </el-dialog>
    </div>
</template>

<script>
import store from '@/store'
import { setToken } from '@/utils/auth.js'
import { PublicInterfaceInfoController } from '@/service/PublicInterfaceInfoController/PublicInterfaceInfoController'
import { OrgBaseConfirmationController } from '@/service/OrgBaseConfirmationController/OrgBaseConfirmationController.js'

export default {
    name: 'firstEntry',
    data() { 
        return {
            // 请求器实例
            publicInterfaceInfoController: new PublicInterfaceInfoController(),
            orgBaseConfirmationController: new OrgBaseConfirmationController(),

            /** 页面加载标识 */
            loading: true,

            /** 显示标识 */
            show: {
                /** 主体内容 -- 显示标识 */
                mainBox: true,
                /** 完善机构信息 -- 弹窗显示标识 */
                dvOrgInfo: false,
                /** 成功提示 -- 显示标识 */
                successBox: false,
            },

            /** 
             * 登录类型标识
             * 1. 商事主体查询不到数据 (查不到企业信息)
             * 2. 总公司，能查出数据
             * 3. 分公司，查不到总公司数据
             * 4. 分公司，能查询到总公司信息
             */
            loginFlag: null,

            /** 表单数据 */
            infoForm: {
                /** 企业名称 */
                OrgName: '',
                /** 企业统一社会信用代码 */
                OrgCode: '',
                /** 
                 * 企业性质
                 * 1：独立法人
                 * 2：非独立法人
                 */
                Nature: '',
                /** 联系人姓名 */
                Contactser: '',
                /** 联系人手机号码 */
                ContactserMoblie: '',
                /** 隶属企业名称 */
                RelationsName: '',
                /** 隶属企业统一社会信用代码 */
                Relations: '',
                /** 备注 */
                Remark: '',
            },

            /** 表单检验规则 */
            infoRules: {
                Nature: [
                    {
                        required: true,
                        message: '请选择企业性质',
                        trigger: 'change',
                    },
                ],
                Contactser: [
                    {
                        required: true,
                        message: '请填写联系人',
                        trigger: 'blur',
                    },
                ],
                ContactserMoblie: [
                    {
                        required: true,
                        message: '请填写联系人手机号码',
                        trigger: 'blur',
                    },
                    {
                        required: true,
                        message: '请填写正确的联系人手机号码',
                        pattern: /^1[3456789]\d{9}$/,
                        trigger: 'blur',
                    },
                ],
                RelationsName: [
                    {
                        required: true,
                        message: '请填写隶属企业名称',
                        trigger: 'blur',
                    },
                    ],
                Relations: [
                    {
                        required: true,
                        message: '请填写统一社会信用代码',
                        trigger: 'blur',
                    },
                ],
            },

            /** 提交确认标识 */
            submitLoading: false,
        }
    },
    mounted() {
        this.onEntry()
    },
    computed: {
        /** 用户省平台跳转编码 */
        code() {
            return localStorage.getItem('code')
        },
        /** 已经选择企业性质 */
        hasNature() { 
            return this.infoForm.Nature !== ''
        },
        /** 企业性质为独立法人 */
        isIndeNature() {
            return this.infoForm.Nature == 1
        },
        /** 企业性质为非独立法人 */
        isNonIndeNature() {
            return this.infoForm.Nature == 2
        },
        /** 无法在商事主体中查询到企业信息 */
        isCompNoData() {
            return this.loginFlag === 1
        },
        /** 分公司且无法在商事主体中查询到总公司信息 */
        isBranchNoCompData() {
            return this.loginFlag === 3
        },
    },
    watch: {},
    methods: {
        /** 进入页面 */
        onEntry() {
            // 模拟进入 (调试可启用)
            // this.mockEnter()
            // return 

            this.publicInterfaceInfoController
                .queryOrgInfoFromSSZT(this.code)
                .then(res => {
                    this.infoForm.OrgName = res?.orgName || ''
                    this.infoForm.OrgCode = res?.orgCode || ''
                    this.loginFlag = res?.loginFlag || null

                    this.handleInfoForm()
                })
                .catch((err) => {
                    this.$message({
                        type: 'error',
                        message: err.Msg,
                    })
                })
                .finally(() => {
                    this.loading = false
                })
        },

        /** 模拟进入 (调试用) */
        mockEnter() {
            setTimeout(() => { 
                this.infoForm.OrgName = '建银工程咨询有限责任公司深圳分公司'
                this.infoForm.OrgCode = '91440300MA5EK7NB3U'
                this.loginFlag = 3

                this.handleInfoForm()

                this.loading = false
            }, 1000)
        },

        /** 表单数据处理 */
        handleInfoForm() {
            // 分公司且无法在商事主体中查询到总公司信息
            if (this.isBranchNoCompData) {
                // 设置企业性质为非独立法人
                this.infoForm.Nature = 2
            }
        },

        /** 选择物业服务企业 */
        selectProp() {
            // 查询不到商事主体 / 为分公司但查询不到总公司信息
            if (this.isCompNoData || this.isBranchNoCompData) { 
                this.show.dvOrgInfo = true
            }
            // 能查询到总公司信息
            else {
                this.toSystem(3)
            }
        },

        /** 选择建设单位 */
        selectBuild() {
            this.toSystem(4)
        },

        /** 
         * 进入系统
         * @param {String} userType 用户选择的类型 3: 物业服务企业 / 4: 建设单位、房地产开发公司
         */
        toSystem(userType) {
            this.loading = true
        
            this.publicInterfaceInfoController
                .CheckUserInfoByCode(this.code, userType)
                .then((res) => {
                    this.handleEnter(res)
                })
                .catch((err) => { 
                    this.$message({
                        type: 'error',
                        message: err.Msg,
                    })
                })
                .finally(() => {
                    setTimeout(() => { 
                        this.loading = false
                    }, 500)
                })
        },

        /** 进入系统处理 */
        handleEnter(res) {
            // 数据解析 
            const token = res.Token

            // 储存令牌
            setToken(token);
            store.commit('SET_TOKEN', token)

            // 跳转首页
            this.$router.push('/index')
        },

        /** 自然人变更 */
        onNatureChange(val) {
            if (val == 1) {
                this.infoForm.RelationsName = '';
                this.infoForm.Relations = '';
            }
        },

        /** 验证表单 */
        onValid() { 
            this.$refs.infoFormRef.validate((valid) => { 
                // 表单验证通过
                if (valid) { 
                    this.onSubmit()
                }
                // 表单验证失败
                else {
                    this.$message({
                        type: 'error',
                        message: '请填写正确表单信息后再提交！'
                    })
                }
            })
        },

        /** 提交表单 */
        onSubmit() {
            this.submitLoading = true

            this.orgBaseConfirmationController
                .addOrgBaseConfirmation(JSON.stringify(this.infoForm))
                .then(res => {
                    this.$message({
                        type: 'success',
                        message: '提交成功！',
                    })

                    this.show.mainBox = false
                    this.show.dvOrgInfo = false
                    this.show.successBox = true
                })
                .catch((err) => {
                    this.$message({
                        type: 'error',
                        message: err.Msg,
                    })
                })
                .finally(() => { 
                    this.submitLoading = false
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.page-first-entry {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, #1965ad, #2ba3de, #1965ad);
    overflow: hidden;

    .main-box {
        width: 600px;
        height: 200px;
        background: #fff;
        border-radius: 4px;

        .title {
            padding: 0 10px;
            width: 100%;
            height: 40px;
            line-height: 40px;
            font-weight: bold;
        }

        .cont {
            display: flex;
            align-items: center;
            justify-content: space-around;
            height: calc(100% - 40px);
        }
    }

    .success-box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 600px;
        height: 200px;
        background: #fff;
        border-radius: 4px;
    }

    .tips {
        margin-bottom: 10px;
        color: #f00;
    }

	.entry-form-box {
        width: 100%;

        .form-row {
            $line: 1px solid #e2e2e2;

            display: flex;
            border-left: $line;
            border-top: $line;

            .row-item {
                flex: 1;
                border-right: $line;

                .form-info {
                    height: 36px;
                    line-height: 36px;
                }

                /deep/.el-form-item {
                    min-height: 40px;
                    margin: 0;
                    display: flex;
                    font-size: 16px;

                    .el-form-item__label {
                        margin: 0;
                        background: #fcfcfc;
                        border-right: $line;
                        min-width: 216px;
                        line-height: 40px;
                    }

                    .el-form-item__content {
                        padding: 2px 8px;
                        width: 100%;

                        .el-radio-group {
                            display: flex;
                            align-items: center;
                            height: 36px;

                            .el-radio {
                                margin-bottom: 0;
                            }
                        }
                    }

                    .el-form-item__error {
                        display: block;
                        margin: 4px;
                    }
                }
            }

            &:nth-last-child(1) {
                border-bottom: $line;
            }
        }
	}
}
</style>